import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { BasicIcon, Button, TextInput } from "@pickit/pickit-components";
import CountrySelector from "component/countrySelector/CountrySelector";
import { LoginFormType, LoginTypeProps } from "./types";
import useValidationSchema from "hooks/useValidationSchema";
import "./Login.scss";
import { ReactComponent as Logo } from "./../../assets/canguroLogo.svg";
import { ReactComponent as LogoText } from "./../../assets/pickers.svg";
import { useTranslation } from "react-i18next";
import "./i18n";

const Login: React.FC<LoginTypeProps> = ({
  validationSchema,
  isFetching,
  countryCode,
  testId,
  onSubmit,
  updateCountryCode,
}): JSX.Element => {
  const { t } = useTranslation("login");
  const history = useHistory();
  const [showPassword, togglePasswordVisibility] = useState(false);

  const handleForgotPassword = () => history.push("/restore");

  return (
    <div className="background-login">
      <div className="login-logo-container">
        <Logo />
        <LogoText height={45} width={158} />
      </div>
      <Form
        onSubmit={(values: LoginFormType) => onSubmit(values)}
        validate={useValidationSchema(validationSchema)}
      >
        {({ invalid, handleSubmit }) => (
          <form className="login-form" onSubmit={handleSubmit}>
            <Field
              type="text"
              name="email"
              label={t("user")}
              component={TextInput}
              showClearIcon={false}
              maxLength={50}
              testId={`${testId}-email`}
            />
            <Field
              textType={showPassword ? "text" : "password"}
              name="password"
              label={t("password")}
              showClearIcon={false}
              component={TextInput}
              iconComponent={
                <div
                  className="eye-icon-container"
                  data-testId={`${testId}-show-password`}
                >
                  <BasicIcon
                    name={showPassword ? "eye-off" : "eye"}
                    onClick={() => togglePasswordVisibility((prev) => !prev)}
                  />
                </div>
              }
              maxLength={20}
              testId={`${testId}-password`}
            />
            <p
              className="country-selector-title"
              data-testId={`${testId}-country-selector-title`}
            >
              {t("countryOfOperation")}
            </p>
            <CountrySelector
              actualCountry={countryCode}
              changeCountry={updateCountryCode}
              testId={`${testId}-country-selector`}
            />
              <Button
                disabled={isFetching || invalid}
                data-testId={`${testId}-submit-button`}
                hierarchy="primary"
                label={t("login")}
                size="medium"
                width="220"
                type="submit"
                isSubmitting={isFetching}
              />
          </form>
        )}
      </Form>
        <Button
          hierarchy="minimal"
          size="medium"
          width="220"
          label={t("forgotPassword")}
          onClick={handleForgotPassword}
          data-testId={`${testId}-forgot-password-link`}
        >
          {t("forgotPassword")}
        </Button>
    </div>
  );
};
export default Login;
